import { ClientActions, UpdateClientRequest } from "../domain/clients";
import { updateClientService } from "../infrastructure/services/updateClientService";
import { clientStore } from "../infrastructure/store/clientStore";

export const updateClient = {
  async execute(
    clientId: string,
    identificationType: string,
    identificationNumber: string,
    company: string,
    contactName: string,
    contactEmail: string,
    contactPhone: number,
    billingEmail: string,
    isSameEmail: boolean
  ): Promise<void> {
    const request: UpdateClientRequest =
      await ClientActions().updateClientRequest(
        clientId,
        identificationType,
        identificationNumber,
        company,
        contactName,
        contactEmail,
        contactPhone,
        billingEmail,
        isSameEmail,
      );
    // await updateClientService.execute(request);
    const oldClient = clientStore().memoryClient;
    oldClient.identificationType = request.identificationType;
    oldClient.identificationNumber = request.identificationNumber;
    oldClient.company = request.company;
    oldClient.contactName = request.contactName;
    oldClient.contactEmail = request.contactEmail;
    oldClient.contactPhone = request.contactPhone;
    oldClient.billingEmail = request.billingEmail;
    oldClient.isSameEmail = request.isSameEmail;
    await clientStore().updateClientSession(oldClient);
  },
};
